import { oteApi, o2oApi } from 'yxt-biz-pc/packages/api';

// 获取考试安排信息
export const getArrange = (id, batchId) => {
  return oteApi.get(`/arrange/${id}?batchId=${batchId || ''}`);
};

// 获取补考信息
export const getArrangeResit = (resitId) => {
  return oteApi.get(`/arrange/${resitId}/resit`);
};

// 新建考试安排补考
export const createArrangeMakeup = (arrangeId, bodyObj, navCode, dataPermissionCode, batchId) => {
  return oteApi.post(`/arrange/${arrangeId}/resit` + `?navCode=${navCode || ''}&dataPermissionCode=${dataPermissionCode || ''}&batchId=${batchId || ''}`, bodyObj);
};

// 编辑考试安排补考
export const updateArrangeMakeup = (id, arrangeId, bodyObj, navCode, dataPermissionCode, batchId) => {
  return oteApi.put(`/arrange/${arrangeId}/resit/${id}` + `?navCode=${navCode || ''}&dataPermissionCode=${dataPermissionCode || ''}&batchId=${batchId || ''}`, bodyObj);
};

// 获取学员列表信息
export const getExaminees = (id, bodyObj, isMakeupSelect) => {
  return oteApi.get(`/arrange/${id}/examinees/list${isMakeupSelect ? '?userMustExist=1&add4Resit=1' : ''}`, bodyObj);
};

// 添加考生
export const addExaminees = (id, bodyObj, batchId) => {
  return oteApi.post(`/arrange/${id}/examinees/reg?reqForResit=1&batchId=${batchId || ''}`, bodyObj);
};

// 批量删除考生
export const batchDeleteExaminees = (id, uemIds, batchId) => {
  return oteApi.post(`/arrange/${id}/examinees/batchdelete?reqForResit=1&batchId=${batchId || ''}`, uemIds);
};

// 获取考试加人的状态
export const getRegExaminessProcess = (id, batchId) => {
  return oteApi.get(`/arrange/${id}/examinees/reg-on-process?reqForResit=1&batchId=${batchId || ''}`);
};

// 获取项目中的学员
export const postProjectUsers = (pid, params) => {
  return o2oApi.post(`groupmember/${pid}/groupmemberPage?limit=20&offset=${params.offset}`, params);
};

// 获取项目多班次中的学员
export const postGroupMemberUsers = (taskId, params) => {
  return o2oApi.post(`/groupmember/${taskId}/member/page?limit=20&offset=${params.offset}`, params);
};
